<!--
页面名称: RentingRoom.vue
页面描述: 该页面为-租房
开发人员: Vikanong
开发时间: 2020-04-18
其他说明: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-->
<template>
  <div class='RentingRoom'>
    <filterlist
      @allBussileList='allBussileList'
      @getregion="getregion"
    ></filterlist>
  </div>
</template>

<script>
import filterlist from "../../components/filter";
export default {
  data() {
    return {};
  },
  components: {
    filterlist
  },
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;
  },
  methods: {
    allBussileList(val) {
      this.businessList = val;
      //  console.log('allbuss', val)
    },
    // 获取当前商圈
    getbusiness(val) {
      let name = "";
      this.businessList.forEach(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    // 获取所有行政区域
    getregion(val) {
      // console.log('getregion', val)
      this.getregionList = val;
    }
  },
  computed: {}
};
</script>
<style  lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/Renting/RentingRoom.vue